/* Gavco 2026-11-03 v2: prev/next arrows on the MAIN product gallery (no lightbox needed); thumbnails stay in sync */
(function(){
  function setup(mg){
    if(mg.dataset.gavArrows)return;
    var viewer=mg.querySelector('product-gallery');
    var slider=viewer&&viewer.querySelector('[id^="Slider-"]');
    if(!slider)return;
    mg.dataset.gavArrows='1';
    var thumbsWrap=mg.querySelector('[id^="GalleryThumbnails-"]');
    function slides(){return Array.prototype.filter.call(slider.querySelectorAll('[id^="Slide-"]'),function(s){return !s.classList.contains('hidden')&&!s.hasAttribute('hidden');});}
    function thumbs(){return thumbsWrap?Array.prototype.filter.call(thumbsWrap.querySelectorAll('li[data-target]'),function(t){return getComputedStyle(t).display!=='none';}):[];}
    function idx(){
      var t=thumbs(),i=t.findIndex(function(x){return x.classList.contains('is-active');});
      if(i>-1)return i;
      var s=slides(),a=s.findIndex(function(x){return x.classList.contains('is-active');});
      if(a>-1&&slider.scrollLeft===0)return a;
      var w=s[0]?s[0].offsetWidth:1;return Math.round(slider.scrollLeft/(w||1));
    }
    function go(step){
      var t=thumbs(),s=slides(),n=t.length||s.length;if(n<2)return;
      var i=(idx()+step+n)%n;
      if(t.length){var b=t[i].querySelector('button');if(b)b.click();}
      var target=s[i];
      if(target&&target.offsetWidth>0&&getComputedStyle(target).display!=='none'){slider.scrollTo({left:target.offsetLeft-slider.offsetLeft,behavior:'smooth'});}
      live.textContent='Image '+(i+1)+' of '+n;
    }
    var svg=function(d){return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="'+d+'" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';};
    var mk=function(cls,label,d,step){var b=document.createElement('button');b.type='button';b.className='gav-gal-arrow '+cls;b.setAttribute('aria-label',label);b.setAttribute('aria-controls',viewer.id||'');b.innerHTML=svg(d);b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(step);});return b;};
    var host=viewer;host.classList.add('gav-gal-host');
    var prev=mk('gav-gal-arrow--prev','Previous image','M15 5l-7 7 7 7',-1);
    var next=mk('gav-gal-arrow--next','Next image','M9 5l7 7-7 7',1);
    var live=document.createElement('span');live.className='visually-hidden';live.setAttribute('aria-live','polite');
    host.appendChild(prev);host.appendChild(next);host.appendChild(live);
    var many=(thumbs().length||slides().length)>1;prev.hidden=!many;next.hidden=!many;
    document.addEventListener('keydown',function(e){
      if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
      var a=document.activeElement;
      if(a&&(a.matches('input,select,textarea,[contenteditable],[contenteditable=""]')||a.isContentEditable))return;
      if(document.querySelector('modal-dialog[open],details[open] .menu-drawer'))return;
      if(!many)return;
      e.preventDefault();go(e.key==='ArrowLeft'?-1:1);
    });
  }
  function init(){document.querySelectorAll('media-gallery').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
